/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * The reducer for the page dashboard
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.0
 */

import { combineReducers } from 'redux';

import widgetCostReducer, { IWidgetCostsReducer } from '../components/Widgets/WidgetCosts/widgetCostsReducer';
import widgetMultiBalancesReducer from '../components/Widgets/WidgetMultiBalances/widgetMultiBalancesReducer';
import { IWidgetMultiBalancesReducer } from '../components/Widgets/WidgetMultiBalances/widgetMultiBalancesTypes';
import widgetOrderInquiriesReducer from '../components/Widgets/WidgetOrderInquiries/widgetOrderInquiriesReducer';
import { IWidgetOrderInquiriesReducer } from '../components/Widgets/WidgetOrderInquiries/widgetOrderInquiriesTypes';
import widgetPaymentHistoryReducer from '../components/Widgets/WidgetPaymentHistory/widgetPaymentHistoryReducer';
import { IWidgetPaymentHistoryReducer } from '../components/Widgets/WidgetPaymentHistory/widgetPaymentHistoryTypes';
import { IWidgetPersonalAccountReducer } from '../components/Widgets/WidgetPersonalAccount/types/widgetPersonalAccountType';
import widgetPersonalAccountReducer from '../components/Widgets/WidgetPersonalAccount/widgetPersonalAccountReducer';
import widgetReducer from '../components/Widgets/widgetReducer';
import {
    IWidgetSearchAccountsReducer,
    widgetSearchAccountsReducer,
} from '../components/Widgets/WidgetSearchAccounts/widgetSearchAccountsReducer';
import widgetSubscriberMobileReducer from '../components/Widgets/WidgetSubscriberMobile/widgetSubscriberMobileReducer';
import { IWidgetSubscriberMobileReducer } from '../components/Widgets/WidgetSubscriberMobile/widgetSubscriberMobileTypes';
import widgetSubscriberMaxCostReducer
    from '../components/Widgets/WidgetSubscribersMaxCosts/widgetSubscriberMaxCostsReducer';
import { ISubscriberMaxCostReducer } from '../components/Widgets/WidgetSubscribersMaxCosts/widgetSubscriberMaxCostsType';
import { IWidgetReducerState } from '../components/Widgets/widgetTypes';
import { IWidgetVotingReducer } from '../components/Widgets/WidgetVoting/types/widgetVotingTypes';
import widgetVotingReducer from '../components/Widgets/WidgetVoting/widgetVotingReducer';

export interface IDashboardReducer {
    widgetCosts: IWidgetCostsReducer;
    widgetMultiBalances: IWidgetMultiBalancesReducer;
    widgetOrderInquiries: IWidgetOrderInquiriesReducer;
    widgetPaymentHistory: IWidgetPaymentHistoryReducer;
    widgetPersonalAccount: IWidgetPersonalAccountReducer;
    widgetReducer: IWidgetReducerState;
    widgetSearchAccounts: IWidgetSearchAccountsReducer;
    widgetSubscriberMaxCost: ISubscriberMaxCostReducer;
    widgetSubscriberMobile: IWidgetSubscriberMobileReducer;
    widgetVoting: IWidgetVotingReducer;
}

const dashboardReducer = () => combineReducers<IDashboardReducer>({
    widgetCosts: widgetCostReducer,
    widgetMultiBalances: widgetMultiBalancesReducer,
    widgetOrderInquiries: widgetOrderInquiriesReducer,
    widgetPaymentHistory: widgetPaymentHistoryReducer,
    widgetPersonalAccount: widgetPersonalAccountReducer,
    widgetReducer: widgetReducer,
    widgetSearchAccounts: widgetSearchAccountsReducer,
    widgetSubscriberMaxCost: widgetSubscriberMaxCostReducer,
    widgetSubscriberMobile: widgetSubscriberMobileReducer,
    widgetVoting: widgetVotingReducer,
});

export default dashboardReducer;
